export default {
  aggregates: {
    aggregated: 'Zbirni rezultati',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'prije',
    from: 'od',
    since: 'od',
    unit: {
      DAY: 'dan|dani',
      MONTH: 'mjesec|mjeseci',
      YEAR: 'godina|godine'
    },
    untilNow: 'do sada'
  },
  categoryDetails: {
    average: 'Prosječna vrijednost je {average}. {benchmark}',
    chartLabel: {
      noLabel: 'Ne',
      yesLabel: 'Da'
    },
    description:
      'To pokazuje kako se distribuiraju odgovori tima na sva pitanja u kategoriji.',
    hideOwnAnswers: 'Sakrij vlastite odgovore',
    noResponses: 'Nema odgovora',
    notParticipating: 'Nisi sam/a odgovorio/la na ova pitanja.',
    numberOfPeople: 'Ispitanici',
    sensitiveQuestion: 'Vidljivo samo tebi kao upravitelju.',
    showFollowUpQuestions: 'Prikaži dodatna pitanja',
    toggleButton: {
      overview: 'Pregled',
      questions: 'Pitanja'
    },
    tooltip: {
      barValue: 'nitko | {count} osoba | {count} ljudi',
      barValueAnswers: 'nitko | {count} odgovor | {count} odgovora'
    },
    workWith: 'Kako raditi sa {categoryName}',
    yourResponse: 'Odgovorio/la si:'
  },
  error: {
    couldNotLoadAggregates: 'Nije moguće učitati zbirne rezultate.',
    couldNotLoadResults: 'Nije moguće učitati rezultate.',
    networkError:
      'Došlo je do problema prilikom učitavanja podataka s interneta. Imaš li radnu konekciju?',
    unknown: 'Dogodila se nepoznata pogreška.'
  },
  errors: {
    status: {
      BadRequest: 'Neispravan zahtjev poslužitelju',
      Forbidden: 'Pristup ovom resursu nije dopušten.',
      InternalServerError:
        'Nešto je pošlo po zlu na poslužitelju. Ako se problem nastavi, obratite se korisničkoj podršci.',
      NotFound: 'Nismo uspjeli pronaći ono što tražite',
      Unauthorized: 'Nemate ovlasti za pristup ovom resursu',
      UnknownError: 'Došlo je do nepoznate pogreške.'
    }
  },
  freetext: {
    loadResponses: 'Učitaj odgovore',
    noFreeTextQuestions:
      'Kad u anketi imate pitanja s otvorenim odgovorima, ovdje ćete moći vidjeti sve odgovore.',
    notEnoughResponses: 'Nema dovoljno odgovora.',
    responses: 'Nema odgovora | {count} odgovor | {count} odgovora'
  },
  general: {
    add: 'Dodaj',
    cancel: 'Otkaži',
    entireOrganization: 'Cijela organizacija',
    ok: 'OK'
  },
  groupsComparison: {
    averageForItem:
      '{value} je prosječna vrijednost za pitanja unutar {title}. {compareToBenchmark}',
    currentValue: 'Trenutna vrijednost',
    filter: {
      findGroups: 'Pronađi grupe',
      shouldExportWithHierarchy: 'Uključi podređene grupe'
    },
    loadMore: 'Učitaj više',
    loadMoreInGroup: 'Učitaj više pod {groupName}',
    noone: 'Nitko nije odgovorio',
    noResults:
      'Još nema dovoljno odgovora za ovu grupu. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'su odgovorili',
    nps: 'Neto promotivni rezultat',
    nps_detractors: 'Klevetnici',
    nps_passives: 'Pasivni',
    nps_promoters: 'Promotori',
    questions: 'Pitanja u kategoriji',
    showTrend: 'Prikaži promjenu',
    violationsIn:
      'Prijavljeno je da je došlo do nepravilnosti unutar {groupName}. Obrati se odjelu ljudskih resursa koji ti može reći više i pomoći da riješiš problem.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'Odaberite datum kao početnu točku za povijest.',
      selectDate: 'Prikazivala bi se povijest anketa od {date}.',
      selectedDate: 'Prikazuje povijest anketa od {date}.'
    },
    selectorOptions: {
      custom: 'prilagođeno',
      oneMonth: '1 m',
      oneYear: '12 m',
      sixMonths: '6 m'
    }
  },
  loading: {
    error: {
      link: 'Pokušaj ponovno'
    }
  },
  navbar: {
    administration: 'Administrator',
    currentSurveys: 'Trenutne ankete',
    help: 'Pomoć',
    myActivities: 'Radnje',
    ourResults: 'Rezultati',
    overview: 'Pregled',
    team: 'Tim',
    welcome: 'Dobro došli'
  },
  page: {
    results: 'Svi rezultati'
  },
  resultDetails: {
    backToResults: 'Idi natrag',
    exportData: 'Ivezi',
    exportModal: {
      includeSensitiveQuestions: 'Uključi osjetljiva pitanja',
      loadingMessage: 'Priprema podataka za izvoz, ovo će malo potrajati.',
      saveAsExcelAllGroupsDescription:
        'Izvozom u Excel dobit ćete datoteku s rezultatima za {groupTitle} i sve podređene grupe. Ovo je korisno ako želite provesti vlastitu analizu ili izračune za više grupa.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Izvozom u Excel dobit ćete datoteku s rezultatima za {groupTitle}{segmentInfo}. Ovo je korisno ako želite napraviti vlastitu analizu ili izračune.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Dobit ćete PDF-dokument s rezultatima za sve kategorije i pitanja za odabranu grupu. Korisno kada želite ispisati rezultate.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'Izvoz u PowerPoint omogućit će vam lijepu prezentaciju s rezultatima za {groupTitle}{segmentInfo}. Savršeno za prikazivanje rezultata drugima na velikom ekranu.'
    },
    notes: {
      draggable: {
        explanation: 'Vidljivo samo vama',
        placeholder:
          'Ovdje napišite vlastite bilješke, komentare i zapažanja o anketi.',
        title: 'Osobne bilješke'
      },
      status: {
        initial: 'Automatsko spremanje dok tipkate',
        saved: 'Promjene spremljene!',
        unsaved: 'Uskoro se sprema...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Nema dovoljno odgovora za prikaz rezultata po korisniku'
        },
        description: {
          high: 'Jedna osoba koja je odgovorila tako da je njen prosječni rezultat postao zelen.|Ima {count} osoba koje su odgovorile tako da je njihov prosječni rezultat postao zelen.',
          low: 'Jedna osoba koja je odgovorila tako da je njen prosječni rezultat postao crven.|Ima {count} osoba koje su odgovorile tako da je njihov prosječni rezultat postao crven.',
          medium:
            'Jedna osoba je odgovorila tako da je njen prosječni rezultat postao žut.|Ima {count} osoba koje su odgovorile tako da je njihov prosječni rezultat postao žut.'
        },
        title: 'Nitko|Jedna osoba|{count} osoba'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Tvoj rezultat je isti kao i Pulsᐩ benchmark® za {title}.',
        higherThanBenchmarkValue:
          'Tvoj rezultat je {benchmarkDiff} viši od Pulsᐩ benchmark® za {title} koji iznosi {benchmarkValue}. Lijepo!',
        lowerThanBenchmarkValue:
          'Ti si {benchmarkDiff} niži od Pulsᐩ benchmark® za {title} koji iznosi {benchmarkValue}',
        percentagePoints: 'postotni bodovi'
      },
      enps: {
        button: {
          description:
            'Uputit ćemo te našem partneru, EQI-ju, koji prikuplja usporedne podatke za veliki broj organizacija i pruža detaljniji uvid u tvoj vlastiti eNPS rezultat.',
          title: 'Usporedi svoj eNPS rezultat s drugim organizacijama'
        }
      },
      toggleButton: {
        history: 'Povijest',
        overview: 'Pregled'
      }
    }
  },
  results: {
    aggregated: 'Zbirni',
    chooseSurvey: 'Odaberi anketu',
    finished: 'Završeno',
    published: 'U tijeku'
  },
  resultsmessages: {
    disclaimer:
      'Pulsᐩ AI koristi generativnu umjetnu inteligenciju i može pogriješiti.',
    error: {
      generic:
        'Ups... nešto ne radi kako je očekivano. Pokušajte ponovno učitati stranicu.',
      notEnoughResults:
        'Nema rezultata za prikaz. Odaberite drugu grupu ili anketu kako biste mogli koristiti Pulsᐩ AI.'
    },
    moreInfo: 'Savladajte korištenje Pulsᐩ AI-ja kao voditelj.',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Postavite pitanje o rezultatima...',
    reload: 'Ponovno učitaj stranicu',
    report: 'Prijavi problem',
    send: 'Pošalji',
    suggestionHeader: 'Evo nekoliko prijedloga pitanja koja možete postaviti:',
    suggestions: {
      groupsComparison: {
        1: 'Na koje se skupine trebam usredotočiti?',
        2: 'Postoji li pitanje na kojem bi većina grupa trebala raditi?',
        3: 'Koje skupine pokazuju negativne trendove?',
        4: 'Koje skupine imaju pozitivne trendove?',
        5: 'Koje se skupine negativno ističu?',
        6: 'Koje grupe trebaju moju pažnju?',
        7: 'Što trebam prvo učiniti?'
      },
      overview: {
        1: 'Što trebam učiniti s našim rezultatom?',
        2: 'Kako da to predstavim svom timu?',
        3: 'Sve u svemu, kako izgledaju rezultati?',
        4: 'Koje su top 3 akcije koje bismo trebali poduzeti?',
        5: 'Što mogu poboljšati u svom vodstvu?',
        6: 'Koje rizike imamo?',
        7: 'Što bi se moglo dogoditi ako ne djelujemo?',
        8: 'Što trebam dati prioritet?',
        9: 'Koja je prognoza za moj tim?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Svatko'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Usporedi'
        },
        export: {
          title: 'Izvezi'
        },
        freetext: {
          title: 'Otvoreni odgovor'
        },
        results: {
          title: 'Rezultati ankete'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Nije moguće prikazati statistiku bez rizika od gubitka anonimnosti.',
    others: 'Ostalo | Ostali',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administracija',
    currentSurveys: 'Aktualne ankete',
    dashboard: 'Nadzorna ploča',
    help: 'Pomoć',
    logOut: 'Odjava',
    myActivities: 'Moje radnje',
    ourResults: 'Naši rezultati'
  },
  topbanner: {
    preview: {
      body: 'Sada gledate novu verziju prikaza rezultata Pulsᐩ koja donosi brojne poboljšane značajke! Ako naiđete na nešto što ne radi kako bi trebalo ili imate povratne informacije, javite nam! Ako želite, možete se i vratiti na staru verziju.',
      header: 'Nova verzija!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Tijekom vremenskog razdoblja {startDate} - {endDate} rezultat se smanjio za {CategoryName}.',
        trend_increased:
          'Tijekom vremenskog razdoblja {startDate} - {endDate} rezultat je povećan za {CategoryName}. Nastavite sa dobrim radom!',
        trend_same:
          'Rezultat je ostao isti za {categoryName} tijekom vremenskog razdoblja {startDate} - {endDate}.'
      }
    },
    noTrend: 'Ne postoji starija anketa s kojom bi se mogla usporediti.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'U usporedbi s prethodnom anketom od {oldSurveyDate} rezultat se smanjio za {changeInPercent}% za {tagName}.',
        nps_trend_increased:
          'U usporedbi s prethodnom anketom {oldSurveyDate}, rezultat se povećao za {changeInPercent}% za {tagName}.',
        nps_trend_same:
          'Rezultat je ostao otprilike isti (promjena {changeInPercent}%) za {tagName} od zadnje ankete {oldSurveyDate}.',
        trend_decreased:
          'Tijekom vremenskog razdoblja {startDate} - {endDate} rezultat se smanjio za {tagName}.',
        trend_increased:
          'Tijekom vremenskog razdoblja {startDate} - {endDate} rezultat je povećan za {tagName}',
        trend_same:
          'Rezultat je ostao isti za {categoryName} tijekom vremenskog razdoblja {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Sve grupe',
    cannotChangeGroupsWhileComparing:
      'Dok ste u prikazu usporedbe, istovremeno gledate više grupa.',
    group: 'Grupa',
    segment: 'Segment',
    survey: 'Anketa'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Broj osoba koje su odabrale najmanje jednu radnju',
      totalActions: 'Ukupan broj odabranih radnji'
    },
    title: 'Sažetak radnji'
  },
  widgetAlert: {
    actions: {
      saved: 'Hvala, aktivnost je spremljena.'
    },
    links: {
      tooltip: 'Poveznica se otvara u novom prozoru'
    },
    notEnoughData: 'Ovdje trenutno nema ničega za prikazati.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Najnoviji izvještaj od {surveyDate}.'
      },
      question: {
        info: 'Posljednji put postavljeno {surveyDate} u anketi {surveyTitle}".'
      }
    },
    notEnoughResponses:
      'Još uvijek nema dovoljno odgovora za prikaz bilo čega ovdje.',
    title: 'Kategorije',
    tooltip: {
      value:
        'Ovo je prosječna vrijednost za sve odgovore na pitanja unutar {categoryName} na koje su odgovorili ljudi iz {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      'Došlo je do neočekivane pogreške prilikom učitavanja widgeta. Prvo pokušajte ponovno učitati stranicu. Ako problem i dalje bude prisutan, javite nam se kako bismo ga što prije riješili!',
    hideErrorDetails: 'Sakrij detalje pogreške',
    showErrorDetails: 'Prikaži detalje pogreške',
    title: 'Problem u widgetu!'
  },
  widgetGroupActions: {
    allCategories: 'Unutar svih kategorija',
    freeText: {
      alert: {
        noResults: 'Ništa nije pronađeno. Pokušaj upisati nešto drugo.',
        typeMore: 'Upiši još'
      },
      filterField: {
        placeholder: 'Upiši za pronalaženje komentara'
      },
      numberOfComments: '{numberOfComments} komentara'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title: 'Kako razviti osobnu odgovornost među svojim zaposlenicima'
      }
    },
    noActions: 'Nema radnji za prikaz.',
    noActionsSelectedInCategory: 'Nema odabranih radnji',
    otherActions: 'Vlastite radnje',
    people: 'nitko | {count} osoba | {count} ljudi',
    peopleSelectedActions:
      'Od {peopleResponded} osoba koje su odgovorile samo je 1 odabrala barem jednu radnju ({percentage} %)| Od {peopleResponded} osoba koje su odgovorile, {count} osoba odabralo je barem jednu radnju ({percentage} %)',
    title: 'Odabrane radnje za osobe u  grupi {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 osoba je odabrala ovu radnju| {count} osoba odabralo je ovu radnju'
    }
  },
  widgetGroupPriorities: {
    description:
      'Ovo su najvažnija područja na koja se trenutno treba usredotočiti, prema sudionicima ankete.',
    freeTextResponses: 'Prikaži odgovore otvorenog tipa',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Kako razviti svoj tim uz Pulsᐩ'
      }
    },
    noPriorities: 'Sudionici nisu izabrali prioritete.',
    people: 'nitko | {count} osoba | {count} ljudi',
    thinkImportant: ' mislim da je kategorija "{category}" najvažnija',
    title: 'Prioriteti za osobe u {groupName}'
  },
  widgetNotImplemented: {
    content: 'Još nije implementirano'
  },
  widgetSurveyInfo: {
    endDate: 'Datum završetka:',
    noone: 'Nitko nije odgovorio',
    notEnoughResponses: {
      aggregate:
        'Nedovoljan broj ljudi odgovorio je u zadanom vremenskom razdoblju za prikaz rezultata.',
      completed:
        'Nedovoljan broj ljudi odgovorio je na anketu za prikaz rezultata.',
      published:
        'Još uvijek nema dovoljno ljudi koji su odgovorili na anketu da bi se prikazali rezultati.'
    },
    participation: {
      title: 'Sudjelovanje'
    },
    startDate: 'Datum početka:',
    status: {
      completed: 'Anketa je završena! Ovo su konačni rezultati.',
      published: 'Anketa je još u tijeku. Rezultati su preliminarni.'
    },
    usersInvited: 'Pozvani ljudi:',
    usersResponded: 'Ljudi koji su odgovorili:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Ovo su najnoviji rezultati za {groupName}.'
    },
    notEnoughResponses:
      'Još uvijek nema dovoljno odgovora za prikaz bilo čega ovdje.',
    title: {
      company: 'Cijela organizacija {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS je kratica za Employee Net Promoter Score i mjeri koliko su zaposlenici voljni zagovarati zapošljavanje u svojoj tvrtki.',
      nps_description:
        'NPS je kratica za Net Promoter Score i mjera je koliko je vjerojatno da će ljudi preporučiti nešto drugima.',
      nps_detractors: 'Klevetnici',
      nps_passives: 'Pasivni',
      nps_promoters: 'Promotori',
      value:
        'Ovo je prosječna vrijednost za sve odgovore na pitanja u {tagName} na koje su odgovorili ljudi u {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} tijekom vremena',
    twoTags: '{tag1} i {tag2}'
  }
}
